var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeaderBoard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 44,
    viewBox: "0 0 43 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_7121_5193)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.54417 43.3149L0 38.5601V11.7235L5.54417 6.96875H36.671L42.2151 11.7235V38.5601L36.671 43.3149H5.54417Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.54417 38.3675L0 33.5914V6.77617L5.54417 2H36.671L42.2151 6.77617V33.5914L36.671 38.3675H5.54417Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.54417 40.8341L0 37.8823V21.2214L5.54417 18.2695H36.671L42.2151 21.2214V37.8823L36.671 40.8341H5.54417Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.54417 39.3044L0 36.3393V19.6917L5.54417 16.7266H36.671L42.2151 19.6917V36.3393L36.671 39.3044H5.54417Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M36.7549 43H6.24503C4.20118 40.9562 3.04384 39.7988 1 37.7549V7.24506C3.04384 5.20121 4.20118 4.04384 6.24503 2H36.7549C38.7988 4.04384 39.9562 5.20121 42 7.24506V37.7549C39.9562 39.7988 38.7988 40.9562 36.7549 43Z",
    fill: "#282828"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.876 3.7954L37.3677 5.22361L40.3014 8.03243V36.3348L37.3677 39.1436L35.876 40.5718H6.3155L3.77962 38.1438L1.91499 36.3586V8.05623L3.77962 6.27097L6.3155 3.84302H35.876M36.4976 2.36719H5.69396C3.63044 4.34288 2.46196 5.46165 0.398438 7.43734V36.9299C2.46196 38.9056 3.63044 40.0243 5.69396 42H36.4976C38.5611 40.0243 39.7296 38.9056 41.7931 36.9299V7.43734C39.7296 5.46165 38.5611 4.34288 36.4976 2.36719Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M36.1982 3.05887L37.8378 4.65947L40.9405 7.68828V37.3117L37.8378 40.3406L36.1982 41.9412H5.85224L3.48106 39.6264L1.10989 37.3117V7.68828L3.48106 5.37359L5.85224 3.05887H36.1982ZM36.627 2H5.37295C3.27926 4.04384 2.09369 5.20121 0 7.24506V37.755C2.09369 39.7988 3.27926 40.9562 5.37295 43H36.627C38.7207 40.9562 39.9063 39.7988 42 37.755V7.24506C39.9063 5.20121 38.7207 4.04384 36.627 2Z",
    fill: "#212121"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.7344 20.5859H26.5455H25.3567H24.168H22.9367H21.7479H20.5591H19.3703H18.1814H16.9927H15.7614H14.5726H13.3838H12.1562V21.7986H13.3838H14.5726H15.7614H16.9927H18.1814H19.3455V22.9365V24.1678V25.3788H20.5293V24.1678V22.9365V21.7986H21.7131V22.9365V24.1678V25.3788H22.9257V24.1678V22.9365V21.7986H24.168H25.3567H26.5455H27.7344H28.9232H30.0861V20.5859H28.9232H27.7344Z",
    fill: "#2D6D44"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.533 14.6094H25.3203V15.7643H26.533V14.6094Z",
    fill: "#2D6D44"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3183 17.0032V15.7617H24.1641H22.9219V17.0032H24.1641H25.3183Z",
    fill: "#2D6D44"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7109 28.9654V30.1542V31.343V32.568H22.9236V31.343V30.1542V28.9654V27.7463H24.1658H25.3546H26.5434H27.7323H28.9002V26.5625H27.7323H26.5434H25.3546H24.1658H22.9345H21.7109V27.7341V28.9654Z",
    fill: "#2D6D44"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7072 25.3789H20.5234V26.5627H21.7072V25.3789Z",
    fill: "#2D6D44"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5573 18.1877H21.7461H22.9239V17.0039H21.7461H20.5573H19.3438V18.1877H20.5573Z",
    fill: "#2D6D44"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1773 26.5625H16.9886H15.7573H14.5685H13.3359V27.7463H14.5685H15.7573H16.9886H18.1773H19.3414V28.9654V30.1542V31.343V32.568H20.5252V31.343V30.1542V28.9654V27.7341V26.5625H19.3662H18.1773Z",
    fill: "#2D6D44"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1777 17.0032H19.3417V15.7617H18.1777H16.9453V17.0032H18.1777Z",
    fill: "#2D6D44"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.947 14.6094H15.7344V15.7643H16.947V14.6094Z",
    fill: "#2D6D44"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5417 27.7461H25.3529H24.1641H22.9219V28.9652V30.154V31.3552H24.1641H25.3529H26.5417H27.7306H28.8985V30.154V28.9652V27.7461H27.7306H26.5417Z",
    fill: "#EF5050"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5417 22.9531H25.3529H24.1641H22.9219V24.1674V25.3784H24.1641H25.3529H26.5417H27.7306H28.8985V24.1674V22.9531H27.7306H26.5417Z",
    fill: "#EF5050"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9886 27.7461H15.7573H14.5685H13.3359V28.9652V30.154V31.3552H14.5685H15.7573H16.9886H18.1773H19.3414V30.154V28.9652V27.7461H18.1773H16.9886Z",
    fill: "#EF5050"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9886 22.9531H15.7573H14.5685H13.3359V24.1674V25.3784H14.5685H15.7573H16.9886H18.1773H19.3414V24.1674V22.9531H18.1773H16.9886Z",
    fill: "#EF5050"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7344 18.1875H26.5455H25.3567H24.168H22.9367H21.7479H20.5591H19.3703H18.1814H16.9927H15.7614H14.5726H13.3838H12.1562V19.3681V20.5839H13.3838H14.5726H15.7614H16.9927H18.1814H19.3703H20.5591H21.7479H22.9367H24.168H25.3567H26.5455H27.7344H28.9232H30.0861V19.3681V18.1875H28.9232H27.7344Z",
    fill: "#70E08D"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5434 25.3789H25.3546H24.1658H22.9345H21.7109V26.5627H22.9345H24.1658H25.3546H26.5434H27.7323H28.9002V25.3789H27.7323H26.5434Z",
    fill: "#70E08D"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M26.533 13.3945H25.3203V14.6072H26.533V13.3945Z",
    fill: "#70E08D"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3183 13.3947V12.2109H24.1641H22.9219V13.3947H24.1641H25.3183Z",
    fill: "#70E08D"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9236 14.6127V13.3945H21.7109V14.6127V15.7621H22.9236V14.6127Z",
    fill: "#70E08D"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5234 27.7341V28.9654V30.1542V31.343V32.568H21.7072V31.343V30.1542V28.9654V27.7341V26.5625H20.5234V27.7341Z",
    fill: "#70E08D"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7072 24.1661V22.9348V21.7969H20.5234V22.9348V24.1661V25.3771H21.7072V24.1661Z",
    fill: "#70E08D"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7072 15.7617H20.5234V17.0032H21.7072V15.7617Z",
    fill: "#70E08D"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3662 25.3789H18.1773H16.9886H15.7573H14.5685H13.3359V26.5627H14.5685H15.7573H16.9886H18.1773H19.3662H20.5252V25.3789H19.3662Z",
    fill: "#70E08D"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3438 15.7621H20.5275V14.6127V13.3945H19.3438V14.6127V15.7621Z",
    fill: "#70E08D"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3417 13.3947V12.2109H18.1777H16.9453V13.3947H18.1777H19.3417Z",
    fill: "#70E08D"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M16.947 13.3945H15.7344V14.6072H16.947V13.3945Z",
    fill: "#70E08D"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5417 31.3555H25.3529H24.1641H22.9219V32.5681H24.1641H25.3529H26.5417H27.7306H28.8985V31.3555H27.7306H26.5417Z",
    fill: "#822A2A"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5417 21.7969H25.3529H24.1641H22.9219V22.9518H24.1641H25.3529H26.5417H27.7306H28.8985V21.7969H27.7306H26.5417Z",
    fill: "#822A2A"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9886 31.3555H15.7573H14.5685H13.3359V32.5681H14.5685H15.7573H16.9886H18.1773H19.3414V31.3555H18.1773H16.9886Z",
    fill: "#822A2A"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9886 21.7969H15.7573H14.5685H13.3359V22.9518H14.5685H15.7573H16.9886H18.1773H19.3414V21.7969H18.1773H16.9886Z",
    fill: "#822A2A"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8984 22.9348V24.1661V25.3548V26.5436V27.7325V28.9638V30.1525V31.3413V32.5663H30.0822V31.3413V30.1525V28.9638V27.7325V26.5436V25.3548V24.1661V22.9348V21.7969H28.8984V22.9348Z",
    fill: "#111111"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9193 17.0032H27.7306H26.5309V15.7617H25.3183V17.0032H24.1641H22.9219V18.187H24.1641H25.3529H26.5417H27.7306H28.9193H30.0823V19.3676V20.5564V21.7961H31.3238V20.5564V19.3676V18.1788V17.0032H30.1081H28.9193Z",
    fill: "#111111"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5415 32.5664H25.3527H24.1639H22.9326H21.7438H20.555H19.3662H18.1773H16.9886H15.7573H14.5685H13.3359V33.7502H14.5685H15.7573H16.9886H18.1773H19.3662H20.555H21.7438H22.9326H24.1639H25.3527H26.5415H27.7303H28.8982V32.5664H27.7303H26.5415Z",
    fill: "#111111"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5312 15.7621H27.715V14.6127V13.3945H26.5312V14.6127V15.7621Z",
    fill: "#111111"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M26.533 12.2109H25.3203V13.3947H26.533V12.2109Z",
    fill: "#111111"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3183 13.3945H24.1641H22.9219V14.6127V15.7621H24.1641H25.3183V14.6127V13.3945Z",
    fill: "#111111"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3183 12.2126V11H24.1641H22.9219V12.2126H24.1641H25.3183Z",
    fill: "#111111"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9236 15.7617H21.7109V17.0032H22.9236V15.7617Z",
    fill: "#111111"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9236 12.2109H21.7109V13.3947H22.9236V12.2109Z",
    fill: "#111111"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5234 15.7621H21.7072V14.6127V13.3945H20.5234V14.6127V15.7621Z",
    fill: "#111111"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5275 15.7617H19.3438V17.0032H20.5275V15.7617Z",
    fill: "#111111"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5275 12.2109H19.3438V13.3947H20.5275V12.2109Z",
    fill: "#111111"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3417 15.7621V14.6127V13.3945H18.1777H16.9453V14.6127V15.7621H18.1777H19.3417Z",
    fill: "#111111"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3417 12.2126V11H18.1777H16.9453V12.2126H18.1777H19.3417Z",
    fill: "#111111"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M16.947 12.2109H15.7344V13.3947H16.947V12.2109Z",
    fill: "#111111"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7385 13.3945H14.5547V14.6127V15.7621H15.7385V14.6127V13.3945Z",
    fill: "#111111"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M13.34 30.1525V28.9638V27.7325V26.5436V25.3548V24.1661V22.9348V21.7969H12.1562V22.9348V24.1661V25.3548V26.5436V27.7325V28.9638V30.1525V31.3413V32.5663H13.34V31.3413V30.1525Z",
    fill: "#111111"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1549 19.3676V18.187H13.3824H14.5712H15.76H16.9913H18.1801H19.3442V17.0032H18.1801H16.9477V15.7617H15.7351V17.0032H14.5712H13.3824H12.1936H11V18.1788V19.3676V20.5564V21.7961H12.1549V20.5564V19.3676Z",
    fill: "#111111"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_7121_5193",
    x: 0,
    y: 0.57233,
    width: 42.2188,
    height: 42.7441,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1.42767
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.28 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7121_5193"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7121_5193",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaderBoard);
export default __webpack_public_path__ + "static/media/leaderBoard.9454c5238d6833466026a508652a4400.svg";
export { ForwardRef as ReactComponent };